import { Typography, Link, Grid, Theme } from '@material-ui/core'
import React, { FC } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useTranslation } from 'react-i18next'
import packageJson from '../../../../package.json'
import palette from '../../../theme/palette'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.acolad.darkBlue,
        minHeight: '6vh',
        margin: 'auto',
        color: '#ffffff',
        padding: theme.spacing(2),
    },
    title: {
        fontWeight: 'bold',
    },
    element: {
        textDecoration: 'underline',
    },
}))

const Footer: FC = () => {
    const classes = useStyles()
    const { t } = useTranslation()
    return (
        <footer>
            <Grid container className={classes.root} justify="space-around">
                <Grid item>
                    <Typography style={{ color: palette.white }}>{t('footer.customer_support')}</Typography>
                    <Typography style={{ color: palette.white }}>
                        <Link href="mailto:Uber_Prod_AM@acolad.com" style={{ color: palette.white }}>
                            customersupport@acolad.com
                        </Link>
                        <br />
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography style={{ color: palette.white }}>{t('footer.privacy_policy')}</Typography>
                </Grid>
                <Grid item>
                    <Typography style={{ color: palette.white }}>v{packageJson.version || ''}</Typography>
                </Grid>
            </Grid>
        </footer>
    )
}

export default Footer
